// Components==============
import CircleRadius from 'components/UI/CircleRadius/CircleRadius';
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import RootReflectionModal from 'components/UI/RootReflectionModal/RootReflectionModal';
import { useMediaQ } from 'hooks/useMediaQ';
import { useRedux } from 'hooks/useRedux';
import React, { useContext } from 'react';
import { GlobalRootSkillContext } from 'utilities/GlobalContext/GlobalRootSkill';
import '../../GrowthPortfolio.module.scss';
// =========================

export default function Skills() {
  const skills = useRedux((state) => {
    const skillData = state.authentication?.user.skill_data?.sort(
      (a, b) => b.count - a.count
    );

    return skillData?.map((skill) => ({
      skill: state.skill?.entities.byId[skill.id],
      size: skill.percentage >= 50 ? 'big' : 'small',
    }));
  })?.filter((s) => s.skill) as {
    skill: SkillEntity;
    size: 'small' | 'big';
  }[];

  const { setRootSkillModal } = useContext(GlobalRootSkillContext);

  const innerRing = skills.slice(0, 5);
  const outerRing = skills.slice(5, 11);

  const query = useMediaQ('min', 1325);

  if (!skills.length) return <></>;

  return (
    <>
      {query ? (
        <>
          <CircleRadius skills={outerRing} ring="outer" />
          <CircleRadius skills={innerRing} ring="inner" />
        </>
      ) : (
        <div styleName="mobile-float-wrapper">
          {skills.map((skill) => (
            <ReflectionIcon
              key={skill.skill.id}
              name={skill.skill.name}
              image={`/storage/${skill.skill.icon}`}
              type={skill.size === 'big' ? 'big skill' : 'small skill'}
              onClick={() => setRootSkillModal(skill.skill)}
            />
          ))}
        </div>
      )}
      <RootReflectionModal type="skill" />
    </>
  );
}
